import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { getTeamUrl } from 'Common'

const Breadcrumbs = props => (

  <Breadcrumb separator='»'>

    <Breadcrumb.Item>
      Home
    </Breadcrumb.Item>

    <Breadcrumb.Item>
      <NavLink to={getTeamUrl('my-orders')}>
        My Orders
      </NavLink>
    </Breadcrumb.Item>

    <Breadcrumb.Item>
      {props.subOrder.reference}
    </Breadcrumb.Item>

  </Breadcrumb>

)

Breadcrumbs.propTypes = {
  subOrder: PropTypes.object.isRequired,
}

export default Breadcrumbs
